

























































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { ClockPostProperties, HourFormatEnum, MomentFormat, FormatOptions } from "@/services/posts/postTypes/clock";
import { getTimeZones } from "@/services/timeZones/timeZoneService";
import { TimeZone } from "@/services/timeZones/types";
import { GetLocalizedClockFormats, GetLocalizedHourFormats } from "@/components/posts/PostTypeRegister";
import moment from "moment";
import vSelect from "vue-select";
import validate from "@/directives/validate";
import { propertiesValidators } from "@/components/posts/clock/validators";
import { validateForm } from "@/services/validation/validationService";
import i18n from "@/i18n";

@Component({
    components: {
        vSelect
    },
    directives: {
        validate
    }
})
export default class ClockForm extends Vue {
    @Prop() private properties!: ClockPostProperties;
    @Prop() defaultShowTime!: number;

    localProperties = {} as ClockPostProperties;
    formatOptions = FormatOptions;
    validators = propertiesValidators;

    // local state
    momentFormat = {
        clockOptionOne: "",
        clockOptionTwo: "",
        clockOptionThree: "",
        clockOptionFour: "",
        textOne: "",
        textTwo: "",
        textThree: "",
        textFour: "",
        textFive: ""
    } as MomentFormat;

    timeZones: TimeZone[] = [];

    // lifecycle hooks
    async created() {
        this.timeZones = await getTimeZones();
        const browserLocation = Intl.DateTimeFormat().resolvedOptions().timeZone.split("/")[1];
        const localUtcOffset = this.timeZones.find(x => x.displayName.includes(browserLocation));
        this.timeZones.unshift({
            id: "localtime",
            displayName: i18n.t("posts.clock.timezones.localTime"),
            baseUtcOffset: localUtcOffset ? localUtcOffset.baseUtcOffset : moment().utcOffset.toString(),
            offset: localUtcOffset ? localUtcOffset.offset : moment().utcOffset.toString()
        } as TimeZone).toString();
        this.timeZones.unshift({
            id: "SolutionTimeZone",
            displayName: i18n.t("posts.clock.timezones.solutionTimeZone"),
            baseUtcOffset: localUtcOffset ? localUtcOffset.baseUtcOffset : moment().utcOffset.toString(),
            offset: localUtcOffset ? localUtcOffset.offset : moment().utcOffset.toString()
        } as TimeZone).toString();
        this.localProperties.timeZone = this.localProperties.timeZone || this.timeZones[0].id;
        if (this.properties.clockFormat) {
            this.momentFormat = this.properties.clockFormat;
        } else {
            this.localProperties.clockFormat = this.momentFormat;
            this.$emit("setDefaultValues", JSON.stringify(this.localProperties));
        }
    }

    mounted() {
        this.localProperties = this.properties;
        this.$emit("setDefaultValues", JSON.stringify(this.localProperties));
    }

    // watchers
    @Watch("defaultShowTime")
    onDefaultShowTimeChanged() {
        if (this.localProperties.showTime) return;
        this.$set(this.localProperties, "showTime", this.defaultShowTime);
    }

    // computed
    get localizedClockFormat() {
        return GetLocalizedClockFormats();
    }

    get localizedHourFormats() {
        return GetLocalizedHourFormats();
    }

    formatChange(fromat: string) {
        switch (this.localProperties.format) {
        case "e-b":
            this.setFormat("", ".", "", "", "", "", "h", "mm", "");
            break;
        case "e-us":
            this.setFormat("", ".", "", "", "", "", "h", "mm", "");
            break;
        case "dk":
            this.setFormat("kl.", ":", "", "", "", "", "h", "mm", "");
            break;
        case "swed":
            this.setFormat("", ":", "", "", "", "", "h", "mm", "");
            break;
        case "nor":
            this.setFormat("", ":", "", "", "", "", "h", "mm", "");
            break;
        case "ger":
            this.setFormat("", ":", "Uhr", "", "", "", "h", "mm", "");
            break;
        case "fr":
            this.setFormat("", "h", "", "", "", "", "h", "mm", "");
            break;
        default:
            this.setFormat("", "", "", "", "", "", "", "", "");
            break;
        }

        this.setItemName();
    }

    setFormat(second: string, third: string, fourth: string, prefix: string,
        sufix: string, firstOption: string, secondOption: string,
        thirdOption: string, fourthOption: string) {
        this.momentFormat.textTwo = second;
        this.momentFormat.textThree = third;
        this.momentFormat.textFour = fourth;
        this.momentFormat.textOne = prefix;
        this.momentFormat.textFive = sufix;
        this.momentFormat.clockOptionOne = firstOption;
        this.momentFormat.clockOptionTwo = secondOption;
        this.momentFormat.clockOptionThree = thirdOption;
        this.momentFormat.clockOptionFour = fourthOption;
    }

    get previewClock() {
        return moment().utcOffset(this.utcOffset).format("[" + this.momentFormat.textOne + "]" +
            this.setHourFormat(this.momentFormat.clockOptionOne) +
            "[" + this.momentFormat.textTwo + "]" +
            this.setHourFormat(this.momentFormat.clockOptionTwo) +
            "[" + this.momentFormat.textThree + "]" +
            this.setHourFormat(this.momentFormat.clockOptionThree) +
            "[" + this.momentFormat.textFour + "]" +
            this.setHourFormat(this.momentFormat.clockOptionFour) +
            "[" + this.momentFormat.textFive + "]");
    }

    get utcOffset() {
        const timezone = this.timeZones.find(x => x.id === this.localProperties.timeZone);
        const result = timezone
            ? timezone.offset.charAt(0) !== "-" ? "+".concat(timezone.offset)
                : timezone.offset
            : moment.parseZone(moment()).utcOffset();
        return result;
    }

    setHourFormat(value: string) {
        if (this.localProperties.hourFormat === HourFormatEnum.h24 && (value === "h" || value === "hh")) {
            return value.toUpperCase();
        } else {
            return value;
        }
    }

    setFormatToCustom() {
        this.localProperties.format = "custom";
        this.setItemName();
    }

    timeZoneChanged() {
        this.setItemName();
    }

    async validateData() {
        return await validateForm([this.validators]) && this.previewClock;
    }

    emitData() {
        this.localProperties.clockFormat = this.momentFormat;
        this.$emit("propertiesUpdated", this.localProperties);
    }

    setItemName() {
        var format = this.clockFormatString();
        const timezone = this.timeZones.find(x => x.id === this.localProperties.timeZone);
        var name = this.localProperties.timeZone === "localtime" ? format
            ? `${this.$i18n.t("posts.clock.title")} ${format}` : ""
            : timezone ? `${this.$i18n.t("posts.clock.title")} ${timezone ? timezone.displayName : ""}` : "";
        this.$emit("itemNameUpdated", name);
    }

    clockFormatString() {
        return `${this.localProperties.clockFormat.textOne}${this.localProperties.clockFormat.clockOptionOne}
            ${this.localProperties.clockFormat.textTwo}${this.localProperties.clockFormat.clockOptionTwo}
            ${this.localProperties.clockFormat.textThree}${this.localProperties.clockFormat.clockOptionThree}
            ${this.localProperties.clockFormat.textFour}${this.localProperties.clockFormat.clockOptionFour}
            ${this.localProperties.clockFormat.textFive}`.replace(/\s/g, "").trim();
    }
}
